import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { ApplicationState } from '@mews-commander/types';
import { getServiceTimeUnitPluralKey } from '@mews-commander/legacy-entities/src/utils/serviceTimeUnitLocalization';
import { getCheckedReservationsServiceIds, getSelectedTimeGroupedServices } from '../../../../selectors';
import { StateProps, OwnProps } from './types';
import PrintableOverviewComponent from './PrintableOverview';

export const PrintableOverview = connect(
    createStructuredSelector<ApplicationState, StateProps, OwnProps>({
        // @ts-expect-error $TSFixMeError: Argument of type '{ timeUnitKey: (state: $TSFixMe, { serviceId }: $TSFixMe) => TextKey | undefined; isFetching: OutputSe...
        timeUnitKey: (state: $TSFixMe, { serviceId }: $TSFixMe) =>
            getServiceTimeUnitPluralKey(state, { id: serviceId }),
        timeGroupedServices: getSelectedTimeGroupedServices,
        checkedServiceIds: getCheckedReservationsServiceIds,
    })
)(PrintableOverviewComponent);
